import { SelectCards } from 'components/Form/SelectCards';
import React, { useState } from 'react';
import 'twin.macro';
import _uniq from 'utils/uniq';
import { AddClassroomButton } from 'containers/Demarrage/components/AddClassroomButton';

export interface Props {
  groupedOptions: string[][];
  value: string[];
  onChange: (v: string[]) => void;
}

export function GradeSelector({ groupedOptions, value, onChange }: Props) {
  const [selectedGrades, setSelectedGrades] = useState<string[]>(value || []);

  const customGrades = selectedGrades.filter(
    d => !groupedOptions.flat().includes(d),
  );

  const grades = [...groupedOptions.flat(), ...customGrades];

  const handleCheckboxChange = (newValue: string[]) => {
    setSelectedGrades(newValue);
    onChange(newValue);
  };

  return (
    <>
      {grades.length > 0 && (
        <div tw="mb-4">
          <SelectCards<string, true>
            options={grades.map(e => ({
              description: e,
              value: e,
            }))}
            value={selectedGrades}
            onChange={handleCheckboxChange}
            isMulti
          />
        </div>
      )}

      <AddClassroomButton
        onAdd={v => handleCheckboxChange(_uniq([...selectedGrades, v]))}
      />
    </>
  );
}
